import React, { useCallback, useEffect, useState } from 'react';
import styles from 'components/nonPodiatry/page.module.scss';
import Button from 'components/common/button';
import { actionTypesOfNonPodiatry } from 'reducer/actionType';
import { StateType } from 'reducer';
import { NonPodiatryOptionsType } from 'types/types';
import { usePersistNonPodiatryReducer } from 'reducer/nonPodiatry';
import clsx from 'clsx';
import MetaTag from 'components/meta';

const numberOfRange = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const units = ['Day(s)', 'Week(s)', 'Month(s)', 'Year(s)'];
type Props = {
  options: NonPodiatryOptionsType[] | NonPodiatryOptionsType;
  currentPage?: number;
  nextPage: number;
  isFilter: boolean;
  nextOrSubmitButton: (nextPage: number, submit?: boolean) => void;
};

const titleExperiencing = 'How long have you been experiencing this problem?';

function HowLongExperiencingProblem({
  nextPage,
  nextOrSubmitButton,
  options,
  isFilter,
}: Props) {
  const [error, setError] = useState(false);
  const [errorOnProblem, setErrorOnProblem] = useState(false);
  const [number, setNumber] = useState<string | null>(
    numberOfRange[0].toString(),
  );
  const [unitOfNumber, setUnitOfNumber] = useState<string | null>(units[0]);

  const [title, setTitle] = useState('');
  const [subTitle, setSubTitle] = useState<string | null>('');
  const [questionList, setQuestionList] = useState<string[]>([]);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);

  const [state, dispatch] = usePersistNonPodiatryReducer();
  useEffect(() => {
    if (state) {
      const data = state.find(
        (
          object: StateType,
        ) => object.name === actionTypesOfNonPodiatry.HOW_LONG_EXPERIENCING_PROBLEM,
      );
      if (data.value.length > 0) {
        setNumber(data.value[0]);
        setUnitOfNumber(data.value[1]);
      } else {
        setNumber(numberOfRange[0].toString());
        setUnitOfNumber(units[0]);
      }
    }
  }, []);

  // For Consistently or of problem
  useEffect(() => {
    if (state) {
      const data = state.find(
        (object: StateType) => object.name === actionTypesOfNonPodiatry.CONSISTENTLY_OR_OFF_PROBLEM,
      );
      if (data.value.length > 0) {
        setSelectedItems(data.value);
      }
    }
  }, [state]);

  // For Consistently or of problem
  useEffect(() => {
    if (isFilter && Array.isArray(options)) {
      const findOptions = options.find(
        (
          obj: NonPodiatryOptionsType,
        ) => obj.name === actionTypesOfNonPodiatry.CONSISTENTLY_OR_OFF_PROBLEM,
      );
      if (findOptions) {
        try {
          setQuestionList(findOptions.options);
          setTitle(findOptions.title);
          setSubTitle(findOptions.subTitle);
        } catch (error) {
          console.error('🚀 ~ Error on filter options', error);
        }
      }
    } else if (!Array.isArray(options)) {
      setQuestionList(options.options);
      setTitle(options.title);
      setSubTitle(options.subTitle);
    }
  }, [isFilter, options]);

  const clickNextOrSubmit = async () => {
    if (!number || !unitOfNumber) {
      setErrorOnProblem(true);
      return;
    }

    if (selectedItems.length === 0) {
      setError(true);
      return;
    }

    await dispatch({
      type: actionTypesOfNonPodiatry.HOW_LONG_EXPERIENCING_PROBLEM,
      name: titleExperiencing,
      value: [number, unitOfNumber],
    });

    nextOrSubmitButton(nextPage);
  };

  const onChangeNumber = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setNumber(event.target.value);
    if (unitOfNumber) {
      setError(false);
    }
  };
  const onUnitNumber = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setUnitOfNumber(event.target.value);
    if (number) {
      setError(false);
    }
  };

  const onSelectOptions = useCallback(
    async (item: string) => {
      setSelectedItems([item]);
      await dispatch({
        type: actionTypesOfNonPodiatry.CONSISTENTLY_OR_OFF_PROBLEM,
        name: title,
        value: [item],
      });
      setError(false);
    },
    [title],
  );

  return (
    <>
      <MetaTag title={titleExperiencing} />
      <h2 className={`marginTopZero ${styles.titleText}`}>
        {titleExperiencing}
      </h2>
      {errorOnProblem && (
      <p className="error-message">
        Required. Please select both of these options.
      </p>
      )}
      <div className="flex justify-between gap-3">
        <div className="w-1/2">
          <select
            value={number ?? ''}
            onChange={onChangeNumber}
            style={{ width: '100%' }}
            className={styles.select}
          >
            {numberOfRange.map((name) => (
              <option
                key={name}
                value={name}
              >
                {name}
              </option>
            ))}
          </select>
        </div>
        <div className="w-1/2">
          {/* units */}
          <select
            value={unitOfNumber ?? ''}
            onChange={onUnitNumber}
            style={{ width: '100%' }}
            className={styles.select}
          >
            {units.map((name) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Page seven merge */}
      <div className="mt-4">
        <h2 className={`marginTopZero ${styles.titleText}`}>{title}</h2>
        {subTitle && <p className={styles.titleTextSubText}>{subTitle}</p>}
        {error && (
        <p className="error-message">
          Please select at least one option.
        </p>
        )}

        <div>
          {questionList.map((item) => {
            const isSelected = selectedItems.includes(item);
            return (
              <p
                key={item}
                className={clsx('option', { 'selected-option': isSelected })}
                onClick={() => onSelectOptions(item)}
                onKeyUp={() => {}}
              >
                {item}
              </p>
            );
          })}
        </div>
      </div>
      <div className="next-button-fixed">
        <Button onClick={clickNextOrSubmit}>
          Next
        </Button>
      </div>
    </>
  );
}

export default HowLongExperiencingProblem;
